import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { CTASection } from "@/components/home/CTASection";
import { useT } from "@/context/LanguageContext";
import { ArrowRight } from "@phosphor-icons/react";

export default function ProductCategories() {
  const { lang } = useT();
  const [categories, setCategories] = useState([]);
  useEffect(() => { api.get("/product-categories").then((r) => setCategories(r.data)).catch((e) => console.error("Failed to load categories:", e)); }, [lang]);

  return (
    <div data-testid="products-page">
      <PageHero
        overline="Product categories"
        title="Source virtually any product, at any scale"
        subtitle="From a single carton of samples to full container loads — we cover the categories that move global trade."
        crumbs={[{ label: "Products" }]}
        image="https://images.unsplash.com/photo-1498049794561-7780e7231661?crop=entropy&cs=srgb&fm=jpg&q=85"
      />
      <section className="bg-white py-24 lg:py-28">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {categories.map((c, i) => (
              <Reveal key={c.name} delay={(i % 3) * 0.07}>
                <Link to="/contact?type=quote" data-testid={`product-card-${i}`} className="group relative block h-72 overflow-hidden rounded-xl">
                  <img src={c.image} alt={c.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A192F] via-[#0A192F]/30 to-transparent" />
                  <div className="absolute inset-x-0 bottom-0 flex items-center justify-between p-6">
                    <h3 className="font-heading text-xl font-semibold text-white">{c.name}</h3>
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/15 text-white backdrop-blur-sm transition-all group-hover:bg-teal">
                      <ArrowRight size={18} weight="bold" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
          <p className="mt-12 text-center text-sm text-slate-500">
            Don't see your category? We source across thousands of product lines.{" "}
            <Link to="/contact?type=quote" className="font-semibold text-teal hover:underline">Tell us what you need →</Link>
          </p>
        </div>
      </section>
      <CTASection />
    </div>
  );
}
